import { Injectable, inject } from '@angular/core';

import type { I18nConfig } from '../i18n.tokens';
import {
  CONTEXT_EDITOR_ENABLED,
  ENABLE_TRANSLATION_UI_KEY,
  I18N_CONFIG_TOKEN,
} from '../i18n.tokens';

@Injectable()
export class PhraseAppEditorService {
  private readonly config = inject<I18nConfig>(I18N_CONFIG_TOKEN);
  private readonly editorEnabled = inject(CONTEXT_EDITOR_ENABLED, { optional: true });

  public get installed(): boolean {
    return this.editorInstalled;
  }

  private editorInstalled: boolean = false;

  constructor() {
    if (this.editorEnabled && !this.editorInstalled) {
      this.installEditor(this.config.phraseAppProjectId);
      this.editorInstalled = true;
    }

    // @ts-ignore
    window['enable_translation_editor'] = () => this.setEnable(true);
    // @ts-ignore
    window['disable_translation_editor'] = () => this.setEnable(false);
  }

  private setEnable(enable: boolean): void {
    if ('localStorage' in window) {
      localStorage.setItem(ENABLE_TRANSLATION_UI_KEY, enable ? 'true' : 'false');
      window.location.reload();
    }
  }

  private installEditor(projectId: string): void {
    // @ts-ignore
    window['PHRASEAPP_CONFIG'] = {
      projectId,
      fullReparse: true,
    };

    const phraseapp = document.createElement('script');
    phraseapp.type = 'text/javascript';
    phraseapp.async = true;
    phraseapp.src = [
      'https://',
      'phraseapp.com/assets/in-context-editor/2.0/app.js?',
      new Date().getTime(),
    ].join('');
    const s = document.getElementsByTagName('script')[0];
    s!.parentNode!.insertBefore(phraseapp, s);
  }
}
